module.exports =(function() {
  return function(context) {
    return (function() {
      var $c, $e, $o;
      $e = function(text, escape) {
        return ("" + text).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/'/g, '&#39;').replace(/\//g, '&#47;').replace(/"/g, '&quot;');
      };
      $c = function(text) {
        switch (text) {
          case null:
          case void 0:
            return '';
          case true:
          case false:
            return '' + text;
          default:
            return text;
        }
      };
      $o = [];
      $o.push("<div class='modal-header-wrapper'>\n  <h2>");
      if (this.modalHeaderTitle) {
        $o.push("  " + $e($c(this.modalHeaderTitle)));
      } else {
        $o.push("  Attach asset");
      }
      $o.push("  </h2>\n</div>\n<div class='content'>");
      if (this.showChooseTab) {
        $o.push("  <div class='modal-tabber row toggles'>\n    <div class='" + (['button', 'small', 'tab1', "" + ($e($c(this.activeTab === 'choose' ? 'active' : void 0)))].sort().join(' ').replace(/^\s+|\s+$/g, '')) + "' data-target='choose'>Choose</div>\n    <div class='" + (['button', 'small', 'tab2', "" + ($e($c(this.activeTab === 'upload' ? 'active' : void 0)))].sort().join(' ').replace(/^\s+|\s+$/g, '')) + "' data-target='upload'>Upload</div>\n  </div>");
      }
      $o.push("  <div class='row row-half tab-displays'>\n    <div class='" + (['modal-assets-manager', "" + ($e($c(this.activeTab !== 'choose' ? 'hidden' : void 0)))].sort().join(' ').replace(/^\s+|\s+$/g, '')) + "' id='modal-tab1'></div>\n    <div class='" + (['modal-assets-droparea', "" + ($e($c(this.activeTab !== 'upload' ? 'hidden' : void 0)))].sort().join(' ').replace(/^\s+|\s+$/g, '')) + "' id='modal-tab2'>\n      <div class='" + (['assets-droparea', "" + ($e($c(this.inputId)))].sort().join(' ').replace(/^\s+|\s+$/g, '')) + "'>\n        <label class='dropzone' for='" + ($e($c(this.inputId))) + "'>\n          Click or drag files here to upload\n        </label>\n      </div>");
      if (this.modalAttachText) {
        $o.push("      <em class='subtext'>" + ($e($c(this.modalAttachText))) + "</em>");
      }
      $o.push("    </div>\n  </div>");
      if (this.showChooseTab) {
        $o.push("  <div class='actions hidden row' id='actions-container'></div>");
      }
      $o.push("</div>\n<div class='drag-drop-tint hidden'>\n  <h3>Drop files here...</h3>\n</div>");
      return $o.join("\n").replace(/\s([\w-]+)='true'/mg, ' $1').replace(/\s([\w-]+)='false'/mg, '').replace(/\s(?:id|class)=(['"])(\1)/mg, "").replace(/[\s\n]*\u0091/mg, '').replace(/\u0092[\s\n]*/mg, '');
    }).call(context);
  };

}).call(this);



//////////////////
// WEBPACK FOOTER
// ./app/javascript/backbone/platform/templates/assets/picker.js.hamlc
// module id = 1546
// module chunks = 18